<template>
  <div class="short-answer-container">
    <div class="question-stem">{{question.Question}}</div>
    <div class="helper-text">{{question.HelperText}}</div>
    <div class="answer-choices">
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          :checked="question.Comment === `Strongly Agree`"
          @change="dispatchInput"
          class="radio-button"
          value="Strongly Agree"
          type="radio"
        />
        <div class="answer-choice-label">Strongly Agree</div>
      </div>
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          @change="dispatchInput"
          :checked="question.Comment === `Agree`"
          class="radio-button"
          value="Agree"
          type="radio"
        />
        <div class="answer-choice-label">Agree</div>
      </div>
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          class="radio-button"
          @change="dispatchInput"
          :checked="question.Comment === `Neutral`"
          value="Neutral"
          type="radio"
        />
        <div class="answer-choice-label">Neutral</div>
      </div>
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          @change="dispatchInput"
          :checked="question.Comment === `Disagree`"
          class="radio-button"
          value="Disagree"
          type="radio"
        />
        <div class="answer-choice-label">Disagree</div>
      </div>
      <div class="answer-choice">
        <input
          :name="question.QuestionID"
          @change="dispatchInput"
          :checked="question.Comment === `Strongly Disagree`"
          class="radio-button"
          value="Strongly Disagree"
          type="radio"
        />
        <div class="answer-choice-label">Strongly Disagree</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  methods: {
    dispatchInput(event) {
      this.$emit("dispatch-input", {
        questionId: this.question.QuestionID,
        Comment: event.target.value
      });
    }
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  max-width: 80%;
  font-size: 1em;
  text-align: justify;
  color: #000000;
  margin-bottom: 0.5em;
  line-height: 1.2;
}
.short-answer-container {
  margin-bottom: 3.5em;
  padding-left: 0.5em;
}
.answer {
  height: 1.25em;
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #979797;
  border-bottom: 1px solid grey;
  width: 90%;
  padding: 0.25em;
}
.answer-choice {
  display: flex;
  padding: 0.25em;
}
.answer-choice-label {
  font-family: Arial, Helvetica, sans-serif;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    max-width: 80%;
    font-size: 1.25em;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.5em;
    line-height: 1.2;
  }
  .answer-choice {
    display: flex;
    padding: 0.25em;
    font-size: 1.1em;
  }
}
</style>